import {getHomeUrl} from '@/utils/getHomeUrl';
import {ReactNode} from 'react';
import {Link} from 'react-router-dom';

export default function Header({children}: {children?: ReactNode}) {
  return (
    <div className='fixed top-0 left-0 flex flex-col w-full z-50 bg-white *:font-medium'>
      <article className='flex items-center justify-center border-b border-neutral-100 py-2'>
        <div className='bg-white z-10 flex items-center'>
          <Link to={getHomeUrl()}>
            <img
              src='/assets/muse-logo.png'
              alt='muse-logo'
              className='h-[1.75rem] my-1'
            />
          </Link>
        </div>
      </article>
      {children}
    </div>
  );
}
